export default "__VITE_ASSET__5C3smT$W__"